import api from '../../REST/api';
import TargetSupplierLink from '../../target-suppliers/TargetSupplierLink';
import deriveLinkComponents from '../derive-link-components';

const { Links } = deriveLinkComponents(
  TargetSupplierLink,
  api.getTargetSupplier,
);

export default Links;
